module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray@2x-41995ce3d1deb72cb418d316399a6401.png";